"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontPageImage = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
require("./index.scss");
const className = 'front-page-image';
class FrontPageImage extends react_1.default.PureComponent {
    render() {
        const { src, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames, style: { backgroundImage: `url(${src})` } }, this.props.children && (react_1.default.createElement("div", { className: `${className}__content` }, this.props.children))));
    }
}
exports.FrontPageImage = FrontPageImage;
FrontPageImage.defaultProps = {
    src: null,
};
//# sourceMappingURL=index.js.map